import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import { getContextWithToken } from '@/plugins/services/auth'
import routesFormulaires from './formulaires'
import routesInscriptionAuRegistreEtudiantsCandidats from './inscriptionAuRegistreEtudiantsCandidats'
import routesDemandePermisPsychologueRegulier from './demandePermisPsychologueRegulier'
import routesDemandePermisPsychologueEquivalence from './demandePermisPsychologueEquivalence'
import routesDemandePermisPsychotherapeute from './demandePermisPsychotherapeute'
import routesAttestationNeuropsy from './attestationNeuropsy'
import routesDemandeAccreditationMediationFamiliale from './accreditationMediationFamiliale'
import routesDemandeInscriptionPsychologue from './demandeInscriptionPsychologue'
import routesDemandeReinscriptionPsychologue from './demandeReinscriptionPsychologue'
import routesDemandeRenouvellementPsychologue from './demandeRenouvellementPsychologue'
import routesDemandeInscriptionPsychotherapeute from './demandeInscriptionPsychotherapeute'
import routesDemandeReinscriptionPsychotherapeute from './demandeReinscriptionPsychotherapeute'
import routesDemandeRenouvellementPsychotherapeute from './demandeRenouvellementPsychotherapeute'
import routesFactures from './factures'
import routesErrors from './errors'
import routesInformatives from './informatives'
import routesAddressComplete from './addressComplete'
import routesRepertoire from './repertoire'
import routesDemandeReconnaissanceFormation from './demandeReconnaissanceFormation'
import routesDemandeDispenseFormation from './demandeDispenseFormation'
import routesDemandeDeclarationFormation from './demandeDeclarationFormation'
import routesInspectionProfessionnelle from './inspectionProfessionnelle'
import routesAutoInspection from './autoInspection'
import routesModificationCarteAffaire from './modificationCarteAffaire'
import routesModificationFormationReconnue from './modificationFormationReconnue'
import routesAuthentification from './authentification'
import routesSignalementPratiqueIllegale from './signalementPratiqueIllegale'
import routesDemandeEnquete from './demandeEnquete'
import routesRedirectionIlluxi from './redirectionIlluxi'
import routesModificationServicesReference from './modificationServiceReference'
import routesMiseAJourServiceReference from './miseAJourServiceReference'
import routesAchatServiceReference from './achatServiceReference'

Vue.use(VueRouter)
Vue.use(VueMeta)

const routes = [
  ...routesErrors,
  ...routesFormulaires,
  ...routesInscriptionAuRegistreEtudiantsCandidats,
  ...routesDemandePermisPsychologueRegulier,
  ...routesDemandePermisPsychologueEquivalence,
  ...routesDemandePermisPsychotherapeute,
  ...routesAttestationNeuropsy,
  ...routesDemandeAccreditationMediationFamiliale,
  ...routesDemandeInscriptionPsychologue,
  ...routesDemandeReinscriptionPsychologue,
  ...routesDemandeRenouvellementPsychologue,
  ...routesDemandeInscriptionPsychotherapeute,
  ...routesDemandeReinscriptionPsychotherapeute,
  ...routesDemandeRenouvellementPsychotherapeute,
  ...routesInformatives,
  ...routesFactures,
  ...routesAddressComplete,
  ...routesRepertoire,
  ...routesDemandeReconnaissanceFormation,
  ...routesDemandeDispenseFormation,
  ...routesDemandeDeclarationFormation,
  ...routesInspectionProfessionnelle,
  ...routesAutoInspection,
  ...routesModificationCarteAffaire,
  ...routesModificationFormationReconnue,
  ...routesAuthentification,
  ...routesSignalementPratiqueIllegale,
  ...routesDemandeEnquete,
  ...routesRedirectionIlluxi,
  ...routesModificationServicesReference,
  ...routesMiseAJourServiceReference,
  ...routesAchatServiceReference
]

const router = new VueRouter({
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.meta.guardedByToken) {
    if (to.query.token) {
      const token = to.query.token.replace(/\s/g, "+")
      const encodedToken = encodeURIComponent(token)
      try {
        let result = await getContextWithToken(encodedToken)
        if (to.meta.condition(result.data)) {
          next()
        } else {
          throw "Unauthorized"
        }
      } catch (error) {
        next({ name: "Unauthorized" })
      }
    }
    else {
      next({ name: "Unauthorized" })
    }
  }
  else {
    next()
  }
})

export default router
